import React from "react";
import styles from "../assets/css/manager.module.scss";
import {Card, Container, Grid, Typography} from "@mui/material";

const Manager = (props) => {
    return <div className={styles.container}>
        <Container maxWidth={"md"}>
            <Grid container>
                <Grid item xs={12} md={6} className={styles.title}>

                    <div>
                        <Typography variant={"h6"} component={"h6"}>
                            {props.message}
                        </Typography>


                        <Typography variant={"overline"} component={"p"}>
                            {props.name}
                        </Typography>

                        <Typography variant={"caption"} component={"p"}>
                            {props.position}
                        </Typography>

                    </div>

                </Grid>
                <Grid item xs={12} md={6}>
                    <Card elevation={3} className={styles.card}>
                        <img src={props.img} alt={props.name}/>

                    </Card>
                </Grid>
            </Grid>
        </Container>
    </div>;
};

export default Manager;